<template>
  <div>

    <div class="row">
      <div class="col-xs-12 col-md-12">
        <h2 class="titulo">{{ title }}</h2>
        <loading v-if="!showContent"></loading>
        <ul id="galeria_videos">
          <li v-for="(item, index) in items" @click="setVideoShow(item.codevideo)">
            <img v-if="item.image" :src="item.image">
            <img v-if="!item.image" src="dist/images/sem_imagem.jpg"/>
          </li>
        </ul>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade modal_videos" id="myModalVideo" role="dialog" ref="vuemodal">
      <div class="modal-dialog">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-content embed-responsive embed-responsive-16by9" role="dialog">
          <iframe class="embed-responsive-item" :src="urlShowVideo" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>

      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';

  export default {
    components: {
      Loading
    },
    data() {
      return {
        title: 'Vídeos',
        items: [],
        showContent:false,
        urlShowVideo: ''
      }
    },
    mounted() {
      $(this.$refs.vuemodal).on("hidden.bs.modal", this.onHidden)
    },
    created() {
      let self = this;
      get('videos').then(function (response) {

        // self.items = this.$store.getters['getSiteContent'].result.data.video;
        self.items = response.data.result.data;
        self.showContent = true;
      });
    },
    methods: {
      setVideoShow(video) {
        $('#myModalVideo').modal();
        console.log("opa")
        this.urlShowVideo = "https://www.youtube.com/embed/" + video;
        return this.urlShowVideo;
      },
      onHidden() {
        this.urlShowVideo = null;
        $("#myModalVideo iframe").attr("src", $("#myModalVideo iframe").attr("src"));
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Videos.vue